<template>
    <div class="main-body">
        <div class="header">老年大学</div>
        <div class="out">

          <div class="search2">

              <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

              <div style="clear: both;"></div>
          </div>

          <el-table class="table" size="mini" :data="tableData" :height="th" border
              row-key="goodsClassCode"
              :row-class-name="tableRowClassName"
              :tree-props="{children: 'secondGoodsClassList'}">

              <el-table-column prop="title" label="标题"></el-table-column>
              <el-table-column prop="icon" label="图标">
                  <template slot-scope="scope">
                      <el-popover placement="right" title="" trigger="click">
                          <img :src="imgUrl+scope.row.icon"  style="width: 500px"/>
                          <img slot="reference" :src="imgUrl+scope.row.icon" style="width:50px">
                      </el-popover>
                  </template>
              </el-table-column>

            <el-table-column prop="trainClassName" label="分类"></el-table-column>

            <el-table-column prop="status" label="状态" >
              <template slot-scope="scope">
                <el-popover
                    placement="right"
                    width="160"
                    title="提示"
                    trigger="hover">
                  <p>{{scope.row.status==1?'是否禁?':'是否启用?'}}</p>
                  <div style="text-align: center; margin: 0">
                    <!-- <el-button type="primary" size="mini" @click="updataStatus(scope.row)">取消</el-button> -->
                    <el-button type="primary" size="mini" @click="updateStatus(scope.row)">确定</el-button>
                  </div>
                  <el-tag type="success" slot="reference" v-if="scope.row.status==1">正常</el-tag>
                  <el-tag type="danger" slot="reference" v-if="scope.row.status==2">禁用</el-tag>
                </el-popover>
              </template>
            </el-table-column>


            <el-table-column label="课程总数">
              <template slot-scope="scope">
                <span>{{scope.row.listTrainCourse.length}}</span>
              </template>
            </el-table-column>

              <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="text" size="mini" @click="handleEditCourse(scope.$index, scope.row)">课程</el-button>
                  </template>
              </el-table-column>

          </el-table>

          <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                             background
                             layout="prev, pager, next"
                             :total="totalItems"
                             :page-size="20"
                             @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:attributeList="attributeList" v-on:closeAdd="closeAdd"  v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:attributeList="attributeList" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

      <Course ref="myCourse" v-show="showModalEditCourse" v-on:closeEditCourse="closeEditCourse" v-on:getList="getList"></Course>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Edit from "./Edit";
    import Add from "./Add";
    import Course from "./Course";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,


                showModalAdd:false,
                showModalEdit:false,
              showModalEditCourse:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,

                name:'',
                status:1,

                imgUrl:this.$imgUrl,
            }
        },
        components:{
            Add,Edit,Course
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{


          toggleModalAdd:function(){
              this.showModalAdd = !this.showModalAdd;
              this.$refs.myAdd.init();
          },
          closeAdd:function(){
              this.showModalAdd = !this.showModalAdd;
          },


          handleEdit(index, row) {
            this.$refs.myEdit.init(row);
            this.showModalEdit = !this.showModalEdit;
          },
          closeEdit:function(){
            this.showModalEdit = !this.showModalEdit;
          },

          handleEditCourse(index,row){
            //console.log(index,row);
            this.$refs.myCourse.init(row);
            this.showModalEditCourse = !this.showModalEditCourse;
          },
          closeEditCourse:function(){
            this.showModalEditCourse = !this.showModalEditCourse;
          },


          updateStatus(row){

            var editForm={
              timeStr:timeStr,
              sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
              staffCode:getStaffCode(),
              trainCode: row.trainCode,
              status:row.status==1?2:1,
            }

            this.$axios({
              method: 'post',
              url: this.$shopUrl+"Train/EditClass",
              data: editForm
            }).then((response) => {
                  this.loading = false;
                  if (response.data.error == 0) {
                    this.getList();
                  }else if(response.data.error == 1){
                    this.$message.error(response.data.message)
                  }
                })
          },

          current_change:function(currentPage){
              this.currentPage = currentPage;
              this.getList();
          },

          getList(){

              this.$axios({
                method: 'post',
                url: this.$shopUrl+"Train/CommPage",
                data: {
                  timeStr:timeStr,
                  sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  staffCode: getStaffCode(),
                  pageIndex:this.currentPage,
                  pageSize:this.pageSize,
                }
              }).then( (response)=> {
                  if(response.data.error == 0){
                    this.tableData = response.data.data.pageInfo.list;
                    this.totalItems = response.data.data.pageInfo.total;

                  }else if(response.data.error == 1){
                      this.$message.error(response.data.message)
                  }
              }).catch(function (error) {
                  console.log(error);
              });
          },


        }
    }
</script>

<style lang="scss" scoped>

</style>
